export default __webpack_public_path__ + "locales/sk/Common.json?hash=15abbda0179cbff65231c650f79f5755";